module.exports = __webpack_public_path__ + "img/icon303.54197c75.png";